import { useEffect, useState } from "react";
import axios from "axios";

const FETCH_MESSAGE_REPORT_URL = `${process.env.REACT_APP_BASE_URL_API}/messages/microservices/messageReport`;

function getParam(param) {
  return new URLSearchParams(window.location.search).get(param);
}

/**
 * Veredito de saúde da conta na API Oficial, pronto para o banner.
 *
 * O backend entrega o veredito já mastigado (`hasIssue`, `title`, `message`,
 * `reasons`), então não há regra de negócio aqui — só a busca. Fica num hook
 * porque a tela inicial e o relatório mostram o MESMO aviso: duplicar a
 * chamada em cada uma abriria espaço para elas divergirem com o tempo.
 *
 * Best-effort: qualquer falha devolve `null` e o banner some. Uma conexão que
 * não é Oficial simplesmente nunca tem problema a relatar.
 */
export function useAccountHealth() {
  const [accountHealth, setAccountHealth] = useState(null);

  useEffect(() => {
    let ativo = true;

    const buscar = async () => {
      try {
        const response = await axios.get(FETCH_MESSAGE_REPORT_URL, {
          params: {
            api: getParam("api"),
            secret: getParam("secret"),
          },
        });

        if (!ativo) return;

        setAccountHealth((response && response.data && response.data.accountHealth) || null);
      } catch (error) {
        console.error(error);
      }
    };

    buscar();

    // Evita gravar estado depois que a tela saiu — o relatório troca de aba com
    // a requisição ainda no ar.
    return () => {
      ativo = false;
    };
  }, []);

  return accountHealth;
}

export default useAccountHealth;
